import React, {Component} from '../lib/react.js'
import moment from 'moment'

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'US'
    };
  }

  onChangeType(e) {
    this.setState({type: e === 'US' ? 'Other' : 'US'})
  }

  render() {
    const { date, isExact } = this.props;
    const dateDefault = '05.06';
    let { type } = this.state;
    let dateFormat;

    if (isExact) {
      dateFormat = date && (type === 'US' ? `${moment(date).format('MM/DD/YYYY LT')} US Date` : `${moment(date).format('DD/MM/YYYY HH:mm')} Date`);
    } else {
      dateFormat = date && (type === 'US' ? `${moment(date).format('MM/DD/YYYY')} US Date` : `${moment(date).format('DD/MM/YYYY')} Date`);
    }

    return (
      <span onClick={() => this.onChangeType(type)}>{date ? dateFormat : dateDefault}</span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DateViewer.js